import script from "./OcrVerificationProductsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./OcrVerificationProductsTable.vue?vue&type=script&setup=true&lang=js"

import "./OcrVerificationProductsTable.vue?vue&type=style&index=0&id=fb67e0a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb67e0a4"]])

export default __exports__